import React from "react";
import { Footer } from "../../components";

const FAQ: React.FC = () => {
  const faq = [
    {
      q: "Mediiq est-il une pharmacie ?",
      a: "Non. Mediiq est une plateforme numérique qui connecte les utilisateurs à des pharmacies partenaires autorisées."
    },
    {
      q: "Comment mes données sont-elles protégées ?",
      a: "Toutes les informations sont chiffrées et stockées sur des serveurs sécurisés. Nous ne vendons jamais vos données."
    },
    {
      q: "Qui prépare mes médicaments ?",
      a: "Votre commande est préparée uniquement par les pharmacies partenaires agréées."
    },
    {
      q: "Puis-je envoyer mon ordonnance ?",
      a: "Oui. Vous pouvez scanner ou téléverser votre ordonnance, et elle sera transmise à la pharmacie choisie."
    },
    {
      q: "Comment contacter le support ?",
      a: "Par email à support@mediiq.app ou par téléphone au +225 07 05 70 45 53."
    },
  ];

  return (
    <div className="bg-green-900 min-h-screen text-white flex flex-col">
      <section className="py-16 px-6 text-center bg-green-800">
        <h1 className="text-4xl md:text-6xl font-extrabold text-yellow-400">FAQ - Mediiq</h1>
        <p className="mt-4 text-gray-200 text-lg max-w-2xl mx-auto">
          Réponses aux questions les plus fréquentes.
        </p>
      </section>

      <section className="flex-grow px-6 md:px-16 py-10 space-y-6">
        {faq.map((item, i) => (
          <div
            key={i}
            className="bg-white p-6 rounded-xl text-green-900 shadow-xl hover:shadow-2xl transition"
          >
            <h3 className="text-xl font-bold mb-2">{item.q}</h3>
            <p className="text-green-700">{item.a}</p>
          </div>
        ))}
      </section>

      <Footer />
    </div>
  );
};

export default FAQ;
